<script setup lang="ts">
import type { PropType } from 'vue'

defineProps({
  experiences: {
    type: Object as PropType<{ title: string, date: string, company: string, logo?: string }[]>,
    required: true,
  },
})
</script>

<template>
  <div class="grid gap-10 lg:grid-cols-12 lg:gap-16">
    <h2 class="about-reveal text-4xl font-semibold tracking-tight text-white sm:text-5xl lg:col-span-4">
      {{ $t("global.experiences") }}
    </h2>
    <div class="relative pl-8 lg:col-span-8">
      <!-- the line: its coloured part is drawn by the page while scrolling -->
      <div class="absolute inset-y-2 left-[3px] w-px bg-white/15">
        <div class="about-line-fill size-full origin-top bg-[#b9c9ae]" />
      </div>
      <ol>
        <li
          v-for="experience in experiences"
          :key="experience.title + experience.company"
          class="about-reveal relative flex items-center justify-between gap-6 py-6"
        >
          <span class="absolute -left-8 top-1/2 size-[7px] -translate-y-1/2 rounded-full bg-[#b9c9ae]" />
          <div>
            <p class="text-sm text-white/50">
              {{ experience.date }}
            </p>
            <h3 class="mt-1 text-pretty text-xl font-medium text-white sm:text-2xl">
              {{ experience.title }}
            </h3>
            <p class="mt-0.5 text-white/60">
              {{ experience.company }}
            </p>
          </div>
          <img
            v-if="experience.logo"
            :src="experience.logo"
            :alt="experience.company"
            loading="lazy"
            class="h-9 w-20 shrink-0 object-contain object-right opacity-70 sm:h-10 sm:w-28"
          >
        </li>
      </ol>
    </div>
  </div>
</template>
